import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { Part } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { PartPurchaseOrderDialogComponent } from '../part-po-dialog/part-po-dialog.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-part-cost',
    templateUrl: './part-cost.component.html',
    styleUrls: ['./part-cost.component.scss'],
    standalone: false
})
export class PartCostComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    parts: any;
    orders: any[];
    filter: any;
    isToastVisible = false;
    showAll = false;
    showCosts = true;

    @ViewChild('partsGrid') partsGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        let parts = (await this.uow.getParts()) as Part[];
        if (!this.showAll)
            parts = parts.filter((x) => {
                if (this.showCosts) {
                    if (x.calculatedCost > x.cost) return x;
                } else if (x.cost > x.price && x.price !== 0) return x;
            });
        this.parts = parts;
        this.setTitle();
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
    }

    async toggleShowCostVsPrice() {
        // this.showAll = true;
        this.showCosts = !this.showCosts;
        await this.getData();
    }

    setTitle() {
        let title = this.showCosts ? 'Cost Comparision' : 'Price Comparision';
        this.appInfo.title = title;
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async selectionChange(e) {
        // console.log(e);
    }

    async rowPrepare(e) {
        if (e.rowType === 'data') {
            if (this.showCosts) {
                if (!!e.data.cost && !!e.data.calculatedCost && e.data.calculatedCost !== 0) {
                    if (e.data.calculatedCost > e.data.cost) e.rowElement.className = e.rowElement.className + ' part-cost-yellow';
                    if (e.data.calculatedCost > e.data.cost * 2) e.rowElement.className = e.rowElement.className + ' part-cost-red';
                }
            } else {
                if (!!e.data.cost && !!e.data.price && e.data.price !== 0) {
                    if (e.data.cost > e.data.price) e.rowElement.className = e.rowElement.className + ' part-cost-yellow';
                    if (e.data.cost > e.data.price * 2) e.rowElement.className = e.rowElement.className + ' part-cost-red';
                }
            }
        }
    }

    async save() {
        this.isToastVisible = true;
        await this.uow.commit();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(partId: number) {
        this.router.navigate(['/parts/' + (partId ? partId : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data.id);
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.partsGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.partsGrid.instance.clearSelection();
        }
    }

    async purchaseOrderDialog(partId: number) {
        const modalRef = this.modalService.show(PartPurchaseOrderDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                partId: partId,
            },
        });

        modalRef.content.result.subscribe((result) => {
            if (result.success && !!result.value) {
                this.openPurchaseOrder(result.value);
            }
            modalRef.hide();
        });
    }

    async openPurchaseOrder(id: number) {
        this.router.navigate(['/purchase-orders/' + id]);
    }

    async refreshCalcCosts() {
        this.appInfo.pleaseWaitShow();
        await this.utility.getCalculatedCost();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
